module.exports = __webpack_public_path__ + "static/img/icon-club-large.843a95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcxj/icon-club-large.png
// module id = 1027
// module chunks = 0